<template>
  <GenericDocumentViewer :toolBarHeight="64">
    <template v-slot:menu>
      <div class="pa-3">
        <JobSelect v-model="jobId" :label="$t('servicesystem.common_objects.order.order')" externaledit hideIcon>
        </JobSelect>
      </div>
      <div class="pa-3">
        <span class="mr-2">View</span>
        <QButtonGroup v-model="selectedView" :list="viewOptions" :edit="true" dense noempty>
        </QButtonGroup>
      </div>
    </template>

    <template v-slot:document>
      <v-container v-if="selectedView != 'report'" fluid class="pa-0 ma-0"
        style="height: inherit; overflow: hidden; position: relative;">
        <overlay-loading :loading="loading"></overlay-loading>
        <iframe v-if="checklistUrl" :key="checklistUrl" class="checklistframe" :src="checklistUrl" @load="onloaded()">
        </iframe>
      </v-container>
      <DevXReport v-else :jobId="jobId" dataSet="CheckList" :templateName="undefined" />
    </template>
  </GenericDocumentViewer>
</template>


<script>
import OverlayLoading from "@/components/Sections/OverlayLoading.vue";
import GenericDocumentViewer from "@/components/GenericDocumentViewer.vue";
import JobSelect from "@/components/Inputs/EntityDropdowns/JobSelect2.vue";
import DevXReport from "@/components/DevXReport.vue";

export default {
  name: "ViewCheckLists",
  components: {
    OverlayLoading,
    GenericDocumentViewer,
    JobSelect,
    DevXReport,
  },

  data() {
    return {
      checklistUrl: null,
      loading: true,

      viewOptions: [
        { text: "Editor", value: null },
        { text: "Report", value: "report" },
      ],
      selectedView: null,
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    onloaded() {
      this.loading = false;
    },

    init() {
      this.loading = true;
      this.checklistUrl = "/checklist/#/open-abcdef/job/" + this.jobId //"/checklist/#/entry/3255"
      console.log('checklistUrl', this.checklistUrl);
    },

    getCurrent() {
      this.loading = true;
      this.getCheckListForJob(this.jobId)
        .then((data) => {
          this.data = data;
          console.log(data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {
    jobId: {
      get() {
        return parseInt(this.$route.params.jobId) || null;
      },
      set(v) {
        const id = Number(v) || null;
        if (id === this.jobId) return;

        // Use a NEW object; never mutate this.$route directly
        this.$router.replace({
          name: this.$route.name,
          params: { ...this.$route.params, jobId: id },
          query: { ...this.$route.query },
        });
      },
    },
  },

  watch: {
    jobId() {
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
.checklistframe {
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>